// 登录
const login = () => import('@/views/login/index.vue')

// 首页
const main = () => import('@/views/layout/index.vue')
const blank = () => import('@/views/layout/blank.vue')
const home = () => import('@/views/home/home.vue')
const project = () => import('@/views/project/index.vue')

// 数据
const data = () => import('@/views/data/index.vue')
const dataList = () => import('@/views/data/list.vue')
const dataConfig = () => import('@/views/data/config.vue')
const dataTransaction = () => import('@/views/data/transaction.vue')
const dataHistory = () => import('@/views/data/history.vue')
const dataRecord = () => import('@/views/data/record.vue')

const transactionList = () => import('@/views/transaction/list.vue')
const transaction = () => import('@/views/transaction/index.vue')
const transactionConfig = () => import('@/views/transaction/config.vue')
const transactionRecord = () => import('@/views/transaction/record.vue')
const schedule = () => import('@/views/transaction/schedule.vue')
const transactionHistory = () => import('@/views/transaction/history.vue')
const process = () => import('@/views/transaction/process.vue')
const trace = () => import('@/views/transaction/trace.vue')

const pipelineList = () => import('@/views/pipeline/list.vue')
const pipeline = () => import('@/views/pipeline/index.vue')
const pipelineConfig = () => import('@/views/pipeline/config.vue')
const pipelineSchedule = () => import('@/views/pipeline/schedule.vue')
const pipelineProc = () => import('@/views/pipeline/proc.vue')
const pipelineSetting = () => import('@/views/pipeline/setting.vue')
const proc = () => import('@/views/proc/proc.vue')
const procStep = () => import('@/views/proc/step.vue')

const historyAll = () => import('@/views/history')
const recordAll = () => import('@/views/record')
const procAll = () => import('@/views/proc')
const ediCheck = () => import('@/views/ediCheck/check.vue')

// 权限
const permission = () => import('@/views/permission/permission.vue')

// 用户
const member = () => import('@/views/user/member.vue')
const userInfo = () => import('@/views/user/info.vue')

// 代理
const agent = () => import('@/views/agent/agent.vue')

// 设置
const setting = () => import('@/views/setting/setting.vue')

// 其他
const page404 = () => import('@/views/page404.vue')

const routers = {
  mode: 'history',
  routes: [{
    path: '*',
    component: page404
  },
  {
    name: 'login',
    path: '/login',
    component: login
  },
  {
    name: 'ediCheck',
    path: '/admin/edi_check',
    component: ediCheck
  },
  {
    name: 'dashboard',
    path: '/',
    component: main,
    children: [{
      name: 'project',
      path: 'org/:groupID',
      component: project,
      children: [{
        name: 'home',
        path: 'home',
        component: home
      }, {
        name: 'dataList',
        path: 'datalist',
        component: dataList
      }, {
        name: 'data',
        path: 'data',
        component: data,
        children: [{
          name: 'dataConfig',
          path: 'config',
          component: dataConfig
        }, {
          name: 'dataTransaction',
          path: 'transaction',
          component: dataTransaction
        }, {
          name: 'dataHistory',
          path: 'history',
          component: dataHistory
        }, {
          name: 'dataRecord',
          path: 'record',
          component: dataRecord
        }]
      }, {
        name: 'transactionList',
        path: 'transactionlist',
        component: transactionList
      }, {
        name: 'transaction',
        path: 'transaction',
        component: transaction,
        children: [{
          name: 'transactionConfig',
          path: 'config',
          component: transactionConfig
        }, {
          name: 'transactionRecord',
          path: 'record',
          component: transactionRecord
        }, {
          name: 'schedule',
          path: 'schedule',
          component: schedule
        }, {
          name: 'transactionHistory',
          path: 'history',
          component: transactionHistory
        }]
      }, {
        name: 'pipelineList',
        path: 'pipelinelist',
        component: pipelineList
      }, {
        name: 'pipeline',
        path: 'pipeline',
        component: pipeline,
        children: [{
          name: 'pipelineConfig',
          path: 'config',
          component: pipelineConfig
        }, {
          name: 'pipelineSchedule',
          path: 'schedule',
          component: pipelineSchedule
        }, {
          name: 'pipelineProc',
          path: 'proc',
          component: pipelineProc
        }, {
          name: 'pipelineSetting',
          path: 'setting',
          component: pipelineSetting
        }]
      }, {
        name: 'historyAll',
        path: 'history',
        component: historyAll
      }, {
        name: 'recordAll',
        path: 'record',
        component: recordAll
      }, {
        name: 'procAll',
        path: 'proc',
        component: procAll
      }, {
        name: 'permission',
        path: 'permission',
        component: permission
      }, {
        name: 'member',
        path: 'member',
        component: member
      }, {
        name: 'agent',
        path: 'agent',
        component: agent
      }, {
        name: 'setting',
        path: 'setting',
        component: setting
      }, {
        name: 'user_info',
        path: 'user_info',
        component: userInfo
      }]
    }]
  },
  {
    name: 'blank',
    path: '/blank',
    component: blank,
    children: [{
      name: 'process',
      path: 'process',
      component: process
    }, {
      name: 'trace',
      path: 'trace',
      component: trace
    }, {
      name: 'proc',
      path: 'proc',
      component: proc
    }, {
      name: 'procStep',
      path: 'proc_step',
      component: procStep
    }]
  }]
}
export default routers



// WEBPACK FOOTER //
// ./src/router/routers.js